import { connect } from 'react-redux';

import { IAppState } from '../../../../../common/state';
import { prepareTrackingData } from '../../../../../utils/prepareTrackingData';
import { IMortgageSimpleBannerOwnProps, IMortgageSimpleBannerStateProps, MortgageSimpleBanner } from './mortgage';

export function mapStateToProps(state: IAppState): IMortgageSimpleBannerStateProps {
  const { filters, results, user, breadcrumbs } = state;

  return {
    tracking: prepareTrackingData(filters, results, breadcrumbs, user),
  };
}

export const MortgageSimpleBannerContainer = connect<
  IMortgageSimpleBannerStateProps,
  {},
  IMortgageSimpleBannerOwnProps
>(mapStateToProps)(MortgageSimpleBanner);
